var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevisionUploaded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "#FDF6DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2591_1626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.667 13.6667H17.0003C15.1594 13.6667 13.667 15.1591 13.667 17V27C13.667 28.841 15.1594 30.3334 17.0003 30.3334H27.0003C28.8413 30.3334 30.3337 28.841 30.3337 27V20.3334M29.5003 15.3334L28.4229 14.2559C28.0975 13.9305 27.5698 13.9305 27.2444 14.2559L26.167 15.3334M27.8337 18.6667V14.0834M30.3337 23.6667L27.8845 21.9033C26.6118 20.987 24.8726 21.0817 23.7069 22.1307L20.2937 25.2026C19.1281 26.2517 17.3888 26.3464 16.1162 25.4301L13.667 23.6667M21.167 19.0834C21.167 20.2339 20.2343 21.1667 19.0837 21.1667C17.9331 21.1667 17.0003 20.2339 17.0003 19.0834C17.0003 17.9328 17.9331 17 19.0837 17C20.2343 17 21.167 17.9328 21.167 19.0834Z",
    stroke: "#AD7636",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2591_1626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisionUploaded);
export default __webpack_public_path__ + "static/media/revision_uploaded.a9df86b7c64402d388f1e390a6bf48a2.svg";
export { ForwardRef as ReactComponent };